import WhistleBlowing from '../policies/6 Whistle Blowing Policy ORTU.pdf'
import Harassment from '../policies/9 Harassment and Bullying 2025.pdf'
import Behaviour from '../policies/10 Behaviour management Policy.pdf'
import Complaint from '../policies/15 Complaint Policy.pdf'
import Boundaries from '../policies/67 Profesional Bounderies .pdf'
import missing from '../policies/72 Missing from care  Policy 2025 26.pdf'
import Recruitment from '../policies/73 Recruitment.pdf'
import SafeGuarding from '../policies/Child Safeguarding and Protection 2025 26.pdf'
import Prevention from '../policies/Children Homes Prevention of Bullying Policy.pdf'
import Elmfield from '../policies/Elmfield House CHILDREN GUIDE.pptx'
import Equality from '../policies/Equality and Diversity 25.pdf'
import Leicester from '../policies/Leicester MFH.pdf'
import Localities from '../policies/LOCALITIES ELMFIELD 200626.pdf'
import Statement from '../policies/STATEMENT OF PURPOSE SEPT25.pdf'

export const polfiles = [
    {id: 1,
     title: " Harassment and Bullying 2025",
     file: Harassment
    },

    {id: 2,
     title: " Complaint Policy",
     file: Complaint
    },

    {id: 3,
        title: " Profesional Bounderies",
        file: Boundaries
       },

    {id: 4,
        title: " Recruitment",
        file: Recruitment
    },

    {id: 5,
        title: " Children Homes Prevention of Bullying Policy",
        file: Prevention
    },

    {id: 6,
        title: " Elmfield House CHILDREN GUIDE",
        file: Elmfield
    },

    {id: 7,
        title: " Equality and Diversity 25",
        file: Equality
    },

    {id: 8,
        title: " Missing from care  Policy 2025",
        file: missing
    },

    {id: 9,
        title: " Behaviour management Policy",
        file: Behaviour
    },

    {id: 10,
        title: " Leicester MFH",
        file: Leicester
    },

    {id: 11,
        title: " Child Safeguarding and Protection 2025",
        file: SafeGuarding
    },

    {id: 12,
        title: " LOCALITIES ELMFIELD 200626",
        file: Localities
    },

    {id: 13,
        title: " Whistle Blowing Policy ORTU",
        file: WhistleBlowing
    },

    {id: 14,
        title: " Statement of purpose",
        file: Statement
    }

    /* {id: 15,
        title: " Aims and Objectives Elmfield  AVENUE",
        file: Aims
    } */


   
]